module.exports = __webpack_public_path__ + "img/video-cover.fa6c3aef.png";